import { conditions } from "helpers";
import { ConditionName } from "interfaces";

const Skeleton = () => {
    return (
        <div
            style={{ height: conditions(ConditionName.isComplexDesktop) ? 98 : 80 }}
            role="status"
            className="pl-space-y-8 pl-animate-pulse md:pl-space-y-0 md:pl-space-x-8 rtl:pl-space-x-reverse md:pl-flex md:pl-items-center"
        >
            <div className="pl-w-full">
                <div className="pl-h-2.5 pl-bg-gray-200 pl-rounded-full dark:pl-bg-gray-700 pl-w-48 pl-mb-4"></div>
                <div className="pl-h-2 pl-bg-gray-200 pl-rounded-full dark:pl-bg-gray-700 pl-mb-2.5"></div>
                <div className="pl-h-2 pl-bg-gray-200 pl-rounded-full dark:pl-bg-gray-700 pl-max-w-[460px] pl-mb-2.5"></div>
                <div className="pl-h-2 pl-bg-gray-200 pl-rounded-full dark:pl-bg-gray-700 pl-max-w-[360px]"></div>
            </div>
            <span className="pl-sr-only">Loading...</span>
        </div>
    );
};

export default Skeleton;
